<div class="detail">
  <div>
    <a uiSref="symap.project.projectSettings" class="button mb-10">
      <i class="fa fa-chevron-left mr-5"></i>
      Nastavení
    </a>
  </div>

  <h1>Priority trvalých záborů</h1>

  <div [loading]="loading">
    <div *ngIf="!loading" class="mt-20">
      <fieldset>
        <div class="column-100" (click)="occupationsPriority.enabled = !occupationsPriority.enabled">
          <label>Zobrazovat priority záborů</label>
          <div class="info">
            <gmt-checkbox [gmtChecked]="occupationsPriority.enabled"></gmt-checkbox>
          </div>
        </div>

        <div class="column-100 mt-10">
          <label>Kategorie priorit</label>
         <gmt-button *ngIf="occupationsPriority.categories.length === 0" [clickAction]="addCategory"><i class="fa fa-plus"></i></gmt-button>
        </div>

        <div class="priority-table mt-10" *ngIf="occupationsPriority.categories.length > 1 || occupationsPriority.enabled">
          <div class="priority-table__header">
            <div class="priority-table__col-label"></div>
            <div class="priority-table__col-name">Zobrazený název kategorie</div>
            <div class="priority-table__col-actions"></div>
            <div class="priority-table__col-layer">Mapová vrstva</div>
          </div>

          <div class="priority-table__row" *ngFor="let category of occupationsPriority.categories; let i = index">
            <div class="priority-table__col-label">{{ i === 0 ? 'Výchozí kategorie' : null  }}</div>
            <div class="priority-table__col-name">
              {{ i === 0 ? occupationsPriority.categories[0].name : null }}
              <input *ngIf="i > 0" required type="text" [(ngModel)]="category.name" (blur)="category.name = category.name?.trim()" placeholder="Zadejte název priority" />
            </div>
            <div class="priority-table__col-actions">
              <a *ngIf="i > 0" class="remove-link" (click)="removeCategory(i)"><i class="fa fa-times"></i></a>
            </div>
            <div class="priority-table__col-layer">
              <i class="fa" [style.cursor]="'pointer'" [ngClass]="{'fa-eye': category.visible, 'fa-eye-slash': !category.visible}" (click)="category.visible = !category.visible"></i>
              <span class="priority-color-swatch ml-10" [style.background]="toRgbaString({ r: category.color.r, g: category.color.g, b: category.color.b, a: 0.5 })" [style.border-color]="toRgbaString(category.color)" (click)="$event.stopPropagation(); toggleColorPicker(i)"></span>
              <color-chrome class="priority-color-picker" *ngIf="colorPickerIndex === i" [color]="category.color" (click)="$event.stopPropagation()" (onChange)="onCategoryColorChange(i, $event)" ></color-chrome>
            </div>
          </div>
        </div>

      <!-- Add button-->
      <div class="priority-table mt-10" *ngIf="occupationsPriority.categories.length">
        <div class="priority-table__row">
          <div class="priority-table__col-label"></div>
          <div class="priority-table__col-name">
            <a class="button" [class.disabled]="occupationsPriority.categories.length > maxCategories" (click)="addCategory()"><i class="fa fa-plus"></i></a>
            <span *ngIf="occupationsPriority.categories.length > maxCategories" class="text-muted ml-10">Dosažen maximální počet priorit ({{ maxCategories }}).</span>
          </div>
        </div>
      </div>

    </fieldset>
      <div class="cb text-center">
        <gmt-button [clickAction]="save" [gmtDisabled]="!isValid()">Uložit všechna nastavení</gmt-button>
      </div>
    </div>
  </div>
</div>
